import React from 'react';
import PropTypes from 'prop-types';
import style from './CloseWindowButton.module.css';

function CloseWindowButton({ width, stroke, color, handleClick, display, margin }) {
  return (
    <div onClick={handleClick} style={{ display, margin }}>
      <svg className={style.svg} width={width + 4} height={width + 4}>
        <path
          d={`M2 2 L${width + 2} ${width + 2} M${width + 2} 2 L2 ${width + 2}`}
          stroke={color}
          strokeWidth={stroke} 
        />
      </svg>
    </div>
  );
}
CloseWindowButton.propTypes = {
  width: PropTypes.number.isRequired,
  stroke: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  display: PropTypes.string,
  margin: PropTypes.string,
};
export default CloseWindowButton;
